import React from 'react'
import { useTranslation } from 'react-i18next'

import { useModal } from '@context/ModalsContext'

import { Body1, Heading6 } from '@ui/Typography'
import { ActionIcon } from '@ui/components/ActionIcon'
import { Divider } from '@ui/components/Divider'
import { InfoIcon } from '@ui/icons/Info.icon'

import { useWindowResize } from '@utils/domUtils'

import { AccountDetailedDto } from '@model/AccountDetailedDto'
import { NameDto } from '@model/NameDto'
import { TwoFAProviderItem } from '@model/TwoFactorAuthentication'

import { Box } from '@shared/components/Box'
import { Loading } from '@shared/components/Loading/Loading'

import { TwoFAInfoModal } from '../modals/TwoFAInfo.modal'
import { TwoFactorAuthMethodsList } from './TwoFactorAuthMethodsList'

export interface TwoFactorAuthenticationProps {
  activeProviders: TwoFAProviderItem[]
  account?: AccountDetailedDto
  providers: NameDto[]
  twoFAProvidersActionTypes: NameDto[]
  isTwoFAProvidersLoading: boolean
  onProviderToggle: (provider: NameDto, isActive: boolean) => void
  onAuthActionsProviderToggle: (provider: NameDto, isActive: boolean) => void
  onPhoneNumberChange: (phone: string, provider: NameDto) => void
  onGenerateRecoveryCodes: () => void
}

export const TwoFactorAuthentication: React.FC<TwoFactorAuthenticationProps> = (props) => {
  const { t } = useTranslation()
  const twoFAInfoModal = useModal(TwoFAInfoModal)
  const isMobile = useWindowResize()

  return (
    <Box flex direction='column' gap={isMobile ? 'x24' : 'x32'} fullWidth>
      <Box flex direction='column' gap={isMobile ? 'x24' : 'x32'} maxWidth={500}>
        <Box flex direction='column' gap='x16'>
          <Box flex align='center' gap='x4'>
            <Heading6 semibold>{t('TwoFactorAuth.Two-step authentication')}</Heading6>
            <ActionIcon icon={InfoIcon} onClick={() => twoFAInfoModal.open()} />
          </Box>
          <Body1>{t('Profile.Add an extra layer of security')}</Body1>
        </Box>
        <TwoFactorAuthMethodsList hasRecoveryCodes {...props} />
      </Box>
      <Divider.Horizontal />

      <Box flex direction='column' gap={isMobile ? 'x24' : 'x32'} maxWidth={500}>
        <Box flex direction='column' gap='x16'>
          <Heading6 semibold>{t('Profile.Two-step verification preferences')}</Heading6>
          <Body1>{t('Profile.Choose when you want to receive verification code')}</Body1>
        </Box>
        <Loading isLoading={props.isTwoFAProvidersLoading} showLoadingIcon>
          <TwoFactorAuthMethodsList isAdvancedSettingsList {...props} />
        </Loading>
      </Box>
    </Box>
  )
}
